import React from 'react';
import { createPortal } from 'react-dom';
import { Sparkles, ArrowRight, X, Bell } from 'lucide-react';
import PropTypes from 'prop-types';
import './AnalyzerNavigationBlocker.css';

const AnalyzerNavigationBlocker = ({
  isOpen,
  onConfirm,
  onCancel,
  onLeaveAndNotify,
  title = 'Analysis in Progress',
  message = 'Your analysis is still generating. Leaving now will end it.',
  confirmText = 'End & Leave',
  cancelText = 'Stay Here',
  leaveAndNotifyText = 'Leave & Get Notified'
}) => {
  if (!isOpen) return null;

  return createPortal(
    <div className="analyzer-nav-blocker-overlay">
      <div className="analyzer-nav-blocker-modal">
        {/* Animated background decoration */}
        <div className="analyzer-nav-blocker-bg-decoration">
          <div className="analyzer-nav-blocker-orb analyzer-nav-blocker-orb-1"></div>
          <div className="analyzer-nav-blocker-orb analyzer-nav-blocker-orb-2"></div>
          <div className="analyzer-nav-blocker-orb analyzer-nav-blocker-orb-3"></div>
        </div>

        {/* Icon container with animated ring */}
        <div className="analyzer-nav-blocker-icon-wrapper">
          <div className="analyzer-nav-blocker-icon-ring"></div>
          <div className="analyzer-nav-blocker-icon">
            <Sparkles size={32} />
          </div>
        </div>

        {/* Content */}
        <h2 className="analyzer-nav-blocker-title">{title}</h2>
        <p className="analyzer-nav-blocker-message">{message}</p>

        {/* Progress indicator */}
        <div className="analyzer-nav-blocker-progress">
          <div className="analyzer-nav-blocker-progress-bar">
            <div className="analyzer-nav-blocker-progress-fill"></div>
          </div>
          <span className="analyzer-nav-blocker-progress-text">Analysis running...</span>
        </div>

        {/* Action buttons */}
        <div className="analyzer-nav-blocker-actions">
          <button
            className="analyzer-nav-blocker-btn analyzer-nav-blocker-btn-primary"
            onClick={onCancel}
          >
            <span>{cancelText}</span>
          </button>
          <div className="analyzer-nav-blocker-actions-row">
            {onLeaveAndNotify && (
              <button
                className="analyzer-nav-blocker-btn analyzer-nav-blocker-btn-notify"
                onClick={onLeaveAndNotify}
              >
                <Bell size={15} />
                <span>{leaveAndNotifyText}</span>
              </button>
            )}
            <button
              className="analyzer-nav-blocker-btn analyzer-nav-blocker-btn-secondary"
              onClick={onConfirm}
            >
              <span>{confirmText}</span>
              <ArrowRight size={15} />
            </button>
          </div>
        </div>

        {/* Close button */}
        <button className="analyzer-nav-blocker-close" onClick={onCancel}>
          <X size={20} />
        </button>
      </div>
    </div>,
    document.body
  );
};

AnalyzerNavigationBlocker.propTypes = {
  isOpen: PropTypes.bool,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  onLeaveAndNotify: PropTypes.func,
  title: PropTypes.string,
  message: PropTypes.string,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  leaveAndNotifyText: PropTypes.string
};

AnalyzerNavigationBlocker.defaultProps = {
  isOpen: false,
  onConfirm: () => {},
  onCancel: () => {},
  onLeaveAndNotify: null,
  title: 'Analysis in Progress',
  message: 'Your analysis is still generating. Leaving now will end it.',
  confirmText: 'End & Leave',
  cancelText: 'Stay Here',
  leaveAndNotifyText: 'Leave & Get Notified'
};

export default AnalyzerNavigationBlocker;
